<template>
  <textarea id="larabergEditor" name="larabergEditor" hidden v-html="modelValue"></textarea>
</template>

<script>
export default {
  name: 'LarabergEditor',
  data: () => ({
    lastValue: '',
    interval: false
  }),
  emits: ['update:modelValue'],
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
  async mounted() {
    if(!document.querySelector('.block-editor-container'))
      await this.$laraberg().init('larabergEditor', this.$larabergOptions());
    this.syncContent();
  },
  watch: {
    modelValue: function (newVal) {
      this.setContent(newVal)
    },
  },
  methods: {
    input(value) {
      this.$emit('update:modelValue', value);
    },
    async setContent(value) {
      if (value !== this.lastValue) {
        try {
          await clearInterval(this.interval);
          await document.querySelector('.block-editor-container').remove();
          await this.$laraberg().init('larabergEditor', this.$larabergOptions());
          this.syncContent();
        } catch (e) {
          console.error(e)
        }
      }
    },
    syncContent() {
      this.interval = setInterval(() => {
        const el = document.querySelector('#larabergEditor');
        if (el) {
          const value = el.innerText;
          if (value !== this.lastValue) {
            this.lastValue = value;
            this.input(this.lastValue);
          }
        }
      }, 500)
    },
  },
  created() {
    this.$laraberg = function() {
      return Laraberg;
    }

    this.$larabergOptions = function() {
      return {
        height: '100vh'
      };
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  }
}
</script>